export default "__VITE_ASSET__DO5sfGwO__"